# GraphQL fragment to get basic info about a step template
# within the sales automation environment.

#import "./assignable-fragment.graphql"

fragment TaskTemplateDueDate on ClosedLeadTaskTemplateDueDate {
    dueUnit
    dueTimespan
}

fragment SalesAutomationTaskTemplate on ClosedLeadTaskTemplate {
    id
    name
    description
    dueDate {
        ...TaskTemplateDueDate
    }
    assignee {
        ...SalesAutomationAssignable
    }
}
